import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/* tailwind-merge can't tell a custom FONT-SIZE utility from a text colour —
 * both are `text-*` — so without this it classed text-body/text-heading as
 * colours: cn('text-muted-foreground text-body') silently dropped the colour
 * and cn('text-body', 'text-white') dropped the size. Registering the ramp
 * as font-sizes restores both merges. */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', 'body', 'row', 'heading'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
